import { render, staticRenderFns } from "./PagePreferredRecipes.vue?vue&type=template&id=05999269&scoped=true"
import script from "./PagePreferredRecipes.vue?vue&type=script&lang=js"
export * from "./PagePreferredRecipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05999269",
  null
  
)

export default component.exports